import {Tooltip} from '@dropbox/dig-components/tooltips';
import {StatusChip} from 'components/DSYS/StatusChip';

import styles from './Roadmap.module.css';
import {getRoadmapStatusPresentation, normalizeRoadmapStatus} from './roadmapStatusColors';

export const RoadmapJiraStatus = ({status}: {status: string | null | undefined}) => {
  const normalizedStatus = normalizeRoadmapStatus(status);
  const label = normalizedStatus || 'No Status';
  const presentation = getRoadmapStatusPresentation(normalizedStatus);

  return (
    <div className={styles.roadmapStatusButton}>
      <Tooltip title={label}>
        <div>
          <StatusChip
            status={normalizedStatus ?? 'no_status'}
            asStatus={presentation.asStatus}
            statusColor={presentation.color}
            size="small"
            includeArchived
          />
        </div>
      </Tooltip>
    </div>
  );
};
